import React from "react";
import Tilt from "react-parallax-tilt";

const TiltCard = (props) => {
  return (
    <Tilt>
      <div
        className={`bg-slate-700 rounded-[20px] py-5 px-12 min-h-[280px] flex justify-evenly items-center flex-col border-gray-300 border-2 w-72 h-80 base-wave${props.number}`}
      >
        <img
          src={props.imgUrl}
          alt="Güven Karabulut"
          className="w-24 h-w-24 object-contain"
        />
        <h1 className="text-white text-[20px] font-bold text-center">
          {props.title}
        </h1>
      </div>
    </Tilt>
  );
};

export default TiltCard;
